export class product_gallery {
    constructor() {
        this.Init();
    }
    Init() {
        this.SliderSettings();
    }
    SliderSettings() {

        jQuery('.main_image').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            fade: false,
            infinite: true,
            speed: 500,
            swipeToSlide: true,
            asNavFor: '.thumbnails',
            prevArrow: '<span type="span" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button"></span>',
            nextArrow: '<span type="span" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button"></span>',
        });
        jQuery('.thumbnails').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            asNavFor: '.main_image',
            dots: false,
            centerMode: false,
            focusOnSelect: true,
            arrows: false,
            infinite: true,
            variableWidth: false,
            speed: 500,
            swipeToSlide: true,
            responsive: [{
                breakpoint: 550,
                settings: {
                    slidesToShow: 2,
                },
            },

            ],
        });
        if (jQuery('.thumbnails .slick-slide:not(.slick-cloned)').length == 4) {
            if (jQuery(window).width() > 550) {
                jQuery(".thumbnails .slick-track").addClass("remove_transform");
            }
        }

    }
}